import script from "./TableBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./TableBadge.vue?vue&type=script&setup=true&lang=js"

import "./TableBadge.vue?vue&type=style&index=0&id=37c3a684&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c3a684"]])

export default __exports__